export default "__VITE_ASSET__Chi4900i__"